import { ErrorLoadData } from '../api/DNAApolloClient/DNAApolloClient';
import { ApiMethodExecutingError } from '../service/Errors';
import { ColumnsSettingsViewDict } from '../typings/common';
import { ReportRequestSetData } from '../typings/reports';
import { ReportClient } from '../typings/reportsClient';

export const FETCH_REPORTS = 'FETCH_REPORTS';
export type FETCH_REPORTS = typeof FETCH_REPORTS;

export interface FetchReports {
    type: FETCH_REPORTS;
    login?: string;
}

export function fetchReports(login?: string): FetchReports {
    return {
        type: FETCH_REPORTS,
        login
    };
}

export const UPDATE_REPORTS = 'UPDATE_REPORTS';
export type UPDATE_REPORTS = typeof UPDATE_REPORTS;

export interface UpdateReports {
    type: UPDATE_REPORTS;
    reports: Array<ReportClient>;
}

export function updateReports(reportsData: Array<ReportClient>): UpdateReports {
    return {
        type: UPDATE_REPORTS,
        reports: reportsData
    };
}

export const ADD_REPORT = 'ADD_REPORT';
export type ADD_REPORT = typeof ADD_REPORT;

export interface AddReport {
    type: ADD_REPORT;
    period: ReportRequestSetData;
}

export function addReport(period: ReportRequestSetData): AddReport {
    return {
        type: ADD_REPORT,
        period
    };
}

export const SHOW_REPORTS_GENERAL_ERROR = 'SHOW_REPORTS_GENERAL_ERROR';
export type SHOW_REPORTS_GENERAL_ERROR = typeof SHOW_REPORTS_GENERAL_ERROR;

export interface ShowReportsGeneralError {
    type: SHOW_REPORTS_GENERAL_ERROR;
    error: ErrorLoadData;
}

export function showReportsGeneralError(
    error: ApiMethodExecutingError
): ShowReportsGeneralError {
    return {
        type: SHOW_REPORTS_GENERAL_ERROR,
        error: {
            type: error.getType(),
            message: error.getMessage()
        }
    };
}

export const STOP_REPORTS_LOADING = 'STOP_REPORTS_LOADING';
export type STOP_REPORTS_LOADING = typeof STOP_REPORTS_LOADING;

export interface StopReportsLoading {
    type: STOP_REPORTS_LOADING;
}

export const stopReportsLoading: StopReportsLoading = {
    type: STOP_REPORTS_LOADING
};

export const CHANGE_REPORTS_COLUMNS_VISIBILITY =
    'CHANGE_REPORTS_COLUMNS_VISIBILITY';
export type CHANGE_REPORTS_COLUMNS_VISIBILITY = typeof CHANGE_REPORTS_COLUMNS_VISIBILITY;

export const UPDATE_REPORTS_COLUMNS_WIDTH = 'UPDATE_REPORTS_COLUMNS_WIDTH';
export type UPDATE_REPORTS_COLUMNS_WIDTH = typeof UPDATE_REPORTS_COLUMNS_WIDTH;

export const CHANGE_REPORTS_GRID_ORDER = 'CHANGE_REPORTS_GRID_ORDER';
export type CHANGE_REPORTS_GRID_ORDER = typeof CHANGE_REPORTS_GRID_ORDER;

export interface ReportsColumnsVisibilityChangeData {
    type: CHANGE_REPORTS_COLUMNS_VISIBILITY;
    columns: ColumnsSettingsViewDict;
}

export function changeReportsColumnsVisibility(
    columns: ColumnsSettingsViewDict
): ReportsColumnsVisibilityChangeData {
    return {
        type: CHANGE_REPORTS_COLUMNS_VISIBILITY,
        columns
    };
}

export interface UpdateReportsColumnsWidthData {
    type: UPDATE_REPORTS_COLUMNS_WIDTH;
    columns: ColumnsSettingsViewDict;
}

export function updateReportsColumnsWidthData(
    columns: ColumnsSettingsViewDict
): UpdateReportsColumnsWidthData {
    return {
        type: UPDATE_REPORTS_COLUMNS_WIDTH,
        columns
    };
}

export interface ReportsColumnsOrderChangeData {
    type: CHANGE_REPORTS_GRID_ORDER;
    columnOrder: Array<string>;
}

export function changeReportsColumnsOrder(
    columnOrder: Array<string>
): ReportsColumnsOrderChangeData {
    return {
        type: CHANGE_REPORTS_GRID_ORDER,
        columnOrder
    };
}

export const HANDLE_REPORTS_COLUMNS_VISIBILITY_CHANGE =
    'HANDLE_REPORTS_COLUMNS_VISIBILITY_CHANGE';
export type HANDLE_REPORTS_COLUMNS_VISIBILITY_CHANGE = typeof HANDLE_REPORTS_COLUMNS_VISIBILITY_CHANGE;

export interface HandleReportsColumnsVisibilityChangeAction {
    type: HANDLE_REPORTS_COLUMNS_VISIBILITY_CHANGE;
    columns: string[];
}

export function handleReportsColumnsVisibilityChange(
    columns: string[]
): HandleReportsColumnsVisibilityChangeAction {
    return {
        type: HANDLE_REPORTS_COLUMNS_VISIBILITY_CHANGE,
        columns
    };
}

export const HANDLE_REPORTS_COLUMNS_ORDER_CHANGE =
    'HANDLE_REPORTS_COLUMNS_ORDER_CHANGE';
export type HANDLE_REPORTS_COLUMNS_ORDER_CHANGE = typeof HANDLE_REPORTS_COLUMNS_ORDER_CHANGE;

export interface HandleReportsColumnsOrderChangeAction {
    type: HANDLE_REPORTS_COLUMNS_ORDER_CHANGE;
    columnOrder: string[];
}

export function handleReportsColumnsOrderChange(
    columnOrder: string[]
): HandleReportsColumnsOrderChangeAction {
    return {
        type: HANDLE_REPORTS_COLUMNS_ORDER_CHANGE,
        columnOrder
    };
}

export const HANDLE_REPORTS_COLUMNS_WIDTH_UPDATE =
    'HANDLE_REPORTS_COLUMNS_WIDTH_UPDATE';
export type HANDLE_REPORTS_COLUMNS_WIDTH_UPDATE = typeof HANDLE_REPORTS_COLUMNS_WIDTH_UPDATE;

export interface HandleReportsColumnsWidthUpdateAction {
    type: HANDLE_REPORTS_COLUMNS_WIDTH_UPDATE;
    width: number;
    key: string;
}

export function handleReportsColumnsWidthUpdate(
    width: number,
    key: string
): HandleReportsColumnsWidthUpdateAction {
    return {
        type: HANDLE_REPORTS_COLUMNS_WIDTH_UPDATE,
        width,
        key
    };
}

export const UPDATE_COLUMNS_SETTINGS_REPORTS_STATE =
    'UPDATE_COLUMNS_SETTINGS_REPORTS_STATE';
export type UPDATE_COLUMNS_SETTINGS_REPORTS_STATE = typeof UPDATE_COLUMNS_SETTINGS_REPORTS_STATE;

export interface UpdateColumnsSettingsReportsState {
    type: UPDATE_COLUMNS_SETTINGS_REPORTS_STATE;
    columnsSettings: ColumnsSettingsViewDict;
}

export const updateColumnsSettingsReportsState = (
    columnsSettings: ColumnsSettingsViewDict
): UpdateColumnsSettingsReportsState => {
    return {
        type: UPDATE_COLUMNS_SETTINGS_REPORTS_STATE,
        columnsSettings
    };
};

export type ReportsClientAction =
    | FetchReports
    | UpdateReports
    | AddReport
    | ReportsColumnsVisibilityChangeData
    | UpdateReportsColumnsWidthData
    | ShowReportsGeneralError
    | StopReportsLoading
    | ReportsColumnsOrderChangeData
    | HandleReportsColumnsVisibilityChangeAction
    | HandleReportsColumnsOrderChangeAction
    | HandleReportsColumnsWidthUpdateAction
    | UpdateColumnsSettingsReportsState;
